import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_MSF_89 } from "@/lib/programs/marrakechSidialiFez89";

export default function MarrakechSidialiFez89Page() {
  return <ProgramTemplate program={PROGRAM_MSF_89} variant="msf" showJourneyChronology />;
}
